import { RoutePending } from '@/components/route-pending'
import { createFileRoute,useNavigate } from '@tanstack/react-router'
import * as React from 'react'
import { authManager } from '@/lib/auth'
import { RouteError } from '@/components/route-error'

export const Route = createFileRoute('/impersonate')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ImpersonateHandoff,
})

/**
 * Admin "act as org" handoff. The admin portal opens this route with the
 * impersonation token in the URL hash (kept out of query/referrer logs):
 *   /impersonate#token=<jwt>&shop=<shopId>
 * We store the session and redirect into the dashboard.
 */
function ImpersonateHandoff() {
  const navigate = useNavigate()
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash
    const params = new URLSearchParams(hash)
    const token = params.get('token')
    if (!token) {
      setError('Missing impersonation token.')
      return
    }
    const ok = authManager.impersonateFromToken(token, params.get('org'))
    if (!ok) {
      setError('Invalid impersonation token.')
      return
    }
    // Clear the token from the address bar before navigating.
    window.history.replaceState(null, '', '/impersonate')
    void navigate({ to: '/inventory/stock' })
  }, [navigate])

  return (
    <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
      {error ? <span className="text-destructive">{error}</span> : 'Entering organization…'}
    </div>
  )
}
